import { useEffect, useState } from "react";

export const useDotsLabel = (label?: string) => {
    const [dotsLabel, setDotsLabel] = useState<string>('');

    useEffect(() => {
        const intervalId = setInterval(() => {
            setDotsLabel(prev => {
                switch (prev) {
                    case '..':
                        return '...';
                    case '.':
                        return '..';
                    case '':
                        return '.';
                    default:
                        return '';
                }
            });
        }, 500);

        return () => clearInterval(intervalId);
    }, []); // Empty dependency array - only set up once, removed dotsLabel dependency!

    return (label || '') + dotsLabel;
}